import { render, staticRenderFns } from "./fr.vue?vue&type=template&id=30e6f9cc&scoped=true"
import script from "./fr.vue?vue&type=script&lang=js"
export * from "./fr.vue?vue&type=script&lang=js"
import style0 from "./fr.vue?vue&type=style&index=0&id=30e6f9cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e6f9cc",
  null
  
)

export default component.exports